<script>
import { required } from "vuelidate/lib/validators";
import { equalTo } from "../../../helpers/validators_files";

export default {
  components: {},
  props: {},
  data() {
    return {
      invalidCheck: "",
    };
  },
  validations: {
    invalidCheck: { required, equalTo: equalTo(true) },

    form: ["invalidCheck"],
  },
  methods: {
    // validate
    validate() {
      this.$v.form.$touch();
      var isValid = !this.$v.form.$invalid;
      this.$emit("on-validate", this.$data, isValid);
      return isValid;
    },
  },
};
</script>

<template>
  <!-- start page title -->
  <div>
    <div class="row">
      <hr class="hr-title" />
      <div class="break-title"><h5 class="mb-4">تعليمات وشروط التقديم</h5></div>

      <div class="col-md-12">
        <ol>
          <li>
            <p>
              اذا كان المتقدم وزوجته منتسبان في هيأة الحشد الشعبي يحق لاحدهم فقط التقديم .
            </p>
          </li>
          <li>
            <p>
              يجب ان يكون عمر مقدم الطلب من 18 سنة الى 62 سنة للتقديم على الاستمارة حسب
              شروط المصرف العقاري .
            </p>
          </li>
          <li>
            <p>
              لا يعتمد كتاب تأييد التقاعد للجريح من قبل المصرف العقاري وعليه يجب احضار
              كفيل للمقترض .
            </p>
          </li>
          <li>
            <p>
              اختيار مساحة الوحدة السكنية هو غير نهائي حيث تسلم الوحدة السكنية حسب اسبقية
              التقديم وبناء على التخصيص من قبل هيئة الاستثمار .
            </p>
          </li>
          <li>
            <p>كتابة الارقام بالغة الانجليزية حصراً اين ما وجدت في الاستمارة .</p>
          </li>
          <li>
            <p>تحجب الاستمارة في حال كان هناك اي معلومات غير صحيحة عند التسجيل .</p>
          </li>
        </ol>

        <div class="form-check check-promise mb-3">
          <label class="form-check-label" for="invalidCheck">
            اتعهد بصحة كافة البيانات التي سيتم ادخالها وبخلافه اتحمل كافة التبعات
            القانونية .
          </label>
          <input
            class="form-check-input"
            type="checkbox"
            value=""
            id="invalidCheck"
            v-model="invalidCheck"
            :class="{ 'is-invalid': $v.invalidCheck.$error }"
          />
          <div v-if="$v.invalidCheck.$error" class="invalid-feedback">
            <span v-if="!$v.invalidCheck.required || !$v.invalidCheck.equalTo"
              >للتقديم على الاستمارة يجب الموافقة على التعهد</span
            >
          </div>
        </div>
      </div>
      <!-- <div class="col-md-3">
        <b-button class="play-btn" v-b-modal.modal-center></b-button>
        <p class="text-center mt-3">مشاهدة الفيديو التوضيحي</p>
      </div>

      <b-modal
        id="modal-center"
        centered
        size="xl"
        title="استمارة الوحدات السكنية"
        title-class="font-18"
        hide-footer
      >
        <div class="ratio ratio-16x9">
          <video src="@/assets/video/info.mp4" controls autoplay></video>
        </div>
      </b-modal> -->
    </div>
  </div>
  <!-- end page title -->
</template>
